function Settings() {
  return (
    <div className="p-6 space-y-8">
      <h2 className="text-2xl font-semibold mb-4">Settings</h2>
      <p className="text-gray-600">This is the settings page where you can configure application preferences.</p>
      {/* Add more settings options here */}
    </div>
  );
}

export default Settings;
